<template>
  <div class="main-layout main-layout_fullpage">
    <div class="main-layout__controls">
      <tab-service :active="active" @changeView="changeView" />
    </div>

    <template v-if="active === 'services'">
      <div class="main-layout__head main-layout__head_pb24">
        <h2 class="main-title">{{ $t("navigation.services") }}</h2>
      </div>

      <!-- SERVICES LIST START -->
      <services-list />
      <!-- SERVICES LIST END -->

      <div class="services__wrapper">
        <modal :show="showService" :outside="false" :dark="true" @close="toggleServiceModal">
          <services-add-modal />
        </modal>
      </div>
      <add-btn v-if="$guard('write', 'Services')" @onClick="openNewService" />
    </template>

    <schedule-list
      type="client"
      :params="params"
      :list="clientScheduleList"
      @prevMonth="prevMonth"
      @nextMonth="nextMonth"
      v-else-if="active === 'schedule'"
    />

    <problems-list v-else />

    <!-- SERVICES MODALS DELETE START-->
    <modal
      :show="deleteModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="toggleDeleteModal"
    >
      <delete-modal
        :title="$t('services.deleteTitle')"
        :cancelDeletionTag="servicesDeletionStatus"
        @cancel="toggleDeleteModal"
        @next="deleteConfirm"
      />
    </modal>

    <!-- SERVICES MODALS DELETE END-->

    <!-- SERVICES MODALS ERRORS START-->
    <modal :show="error" :dark="true" @close="toggleDeleteModal">
      <error-modal :okAction="closeModalError">{{ error }}</error-modal>
    </modal>
    <!-- SERVICES MODALS ERRORS END-->
    <!-- SERVICES MODALS -->
  </div>
</template>

<script>
import store from '@/store'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import servicesList from '@/components/lists/services/servicesList'
import scheduleList from '@/components/lists/schedule/scheduleList'
import problemsList from '@/components/lists/problems/problemsList'
import servicesAddModal from '@/components/modals/services/servicesAddModal'
import addBtn from '@/components/controls/addBtn'
import tabService from '@/components/controls/tabService'

const d = new Date()

export default {
    name: 'services',
    components: {
        servicesList,
        servicesAddModal,
        addBtn,
        tabService,
        scheduleList,
        problemsList,
    },
    data() {
        return {
            colorIsOpen: false,
            serviceImage: '',
            serviceIcon: '',
            serviceId: '',
            isEdit: false,
            colors: [],
            active: 'services',
            params: {
                year: d.getFullYear(),
                month: d.getMonth() + 1,
                office_id: null,
            },
            // scheduleServiceId: "all",
            // monthName:
        }
    },
    computed: {
        ...mapGetters({
            getActiveMaterial: 'materials/getActiveMaterial',
            deleteModal: 'deleteModalGetters',
            showService: 'serviceModalGetters',
            servicesDeleteId: 'servicesDeleteId',
            servicesDeletionStatus: 'servicesDeletionStatusGetters',
            clientScheduleList: 'clientScheduleList',
            scheduleServiceId: 'scheduleServiceId',
            filteredList: 'offices/filteredList',
            officeId: 'scheduleOfficeId',
        }),
        error: {
            get() {
                return this.$store.state.services.error
            },
            set(value) {
                this.$store.commit('servicesErrorUpdate', value)
            },
        },
    },
    methods: {
        ...mapMutations({
            toggleDeleteModal: 'setDeleteModal',
            toggleServiceModal: 'setServiceModal',
            emptyServiceData: 'emptyServiceData',
            setEdit: 'setEdit',
            setClientScheduleParams: 'setClientScheduleParams',
            setScheduleOfficeId: 'setScheduleOfficeId',
            setLink: 'setLink',
        }),
        ...mapActions({
            requestForDelete: 'deleteControl/requestForDelete',
            getServices: 'getServices',
            fetchClientSchedule: 'fetchClientSchedule',
            fetchOffices: 'offices/fetch',
        }),
        toggleTodoListModal() {},
        changeView(view) {
            this.active = view
        },
        toggleEditModal() {
            this.showService = !this.showService
        },
        closeModalError() {
            this.error = ''
        },
        openNewService() {
            this.setEdit(false)
            this.emptyServiceData()
            this.toggleServiceModal()
        },
        openDelete(id) {
            this.serviceId = id
            this.showModalDelete = true
        },
        fetchScheduleMonth() {
            this.setClientScheduleParams({
                ...this.params,
                office_id: this.officeId,
            })
            this.fetchClientSchedule()
        },
        prevMonth() {
            if (this.params.month === 1) return
            this.params.month--

            this.fetchScheduleMonth()
        },
        nextMonth() {
            if (this.params.month === 12) return

            this.params.month++

            this.fetchScheduleMonth()
        },
        async deleteConfirm() {
            this.$Progress.start()
            this.showModalDelete = false

            try {
                if (!this.$guard('delete', 'Services')) {
                    await this.requestForDelete({
                        id: this.servicesDeleteId,
                        type: 'services',
                    })
                    await this.getServices()

                    this.toggleDeleteModal()
                    return
                }

                await store.dispatch('deleteService', this.serviceId)
                this.$store.commit('emptyServiceData')
                this.$Progress.finish()
            } catch (err) {
                // error
            }
        },
        fetchSchedule() {
            this.setClientScheduleParams({
                ...this.params,
                office_id: this.officeId,
            })
            this.fetchClientSchedule()
        },
    },

    async created() {
        await this.fetchOffices()
        if (this.filteredList[0]) {
            this.params.office_id = this.filteredList[0].id
            this.setScheduleOfficeId(this.filteredList[0].id)
        }

        await this.getServices()
        this.fetchSchedule()
    },
    mounted() {
        this.setLink({
            key: 'infoRootLink',
            value: 'https://doc.clickup.com/p/h/4hhzv-2201/75b1e289782388f/4hhzv-2201',
        })
        this.setLink({
            key: 'infoLink',
            value: 'https://doc.clickup.com/p/h/4hhzv-861/4729a440adfb296',
        })
    },
    beforeDestroy() {
        if (this.showService) {
            this.toggleServiceModal()
        }
        this.setLink({
            key: 'infoRootLink',
            value: null,
        })
        this.setLink({
            key: 'infoLink',
            value: null,
        })
    },
}
</script>

<style lang="scss">
.app-schedule {
  &__filters {
    display: flex;
    margin-bottom: 24px;
  }

  &__actions {
    display: flex;
    margin-left: auto;
  }

  &__slider {
    display: flex;
    align-items: center;
    margin-right: 12px;

    &-prev,
    &-next {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    &-month {
      width: 153px;
      font-size: 32px;
      font-family: "archivo-medium";
      color: var(--menu-text-color);
      text-align: center;
      user-select: none;
    }
  }

  &__list {
    overflow-y: scroll;
    height: 77vh;

    &_h84 {
      height: 84vh;
    }
  }

  &__container {
    margin-bottom: 24px;
  }

  &__item {
    display: flex;

    &_main {
      height: 42px;
      margin-bottom: 6px;
    }

    &-date {
      font-family: "crosten-bold";
      color: var(--label-color);
      font-size: 11px;
      width: 90px;
      min-width: 70px;

      span {
        font-size: 10px;
        font-family: "crosten";
      }
    }

    &-service {
      width: 52px;
      min-width: 52px;
      padding: 10px 16px;

      img {
        width: 20px;
        height: 20px;
      }
    }

    &-view {
      width: 92%;
    }

    &-actions {
      width: 58px;
      min-width: 58px;

      &_p {
        padding: 10px 0 10px 20px;
      }
    }
  }

  .schedule-row {
    border: 1px solid var(--border-color);
    &_head {
      border-bottom: unset;
    }

    &__head,
    &__body {
      display: flex;
    }

    &__head {
      height: 24px;
      font-family: "crosten-bold";
      color: var(--label-color);
      font-size: 11px;
    }

    &__body {
      height: 40px;
      position: relative;
      overflow: hidden;

      &_pointer {
        cursor: pointer;
      }

      &_yellow {
        background-color: #f8cc1c;
      }
    }

    &__time {
      width: 20%;
      position: absolute;
      // background-color: red;
      height: 40px;
      left: 30%;
    }
    &__hour {
      width: calc(100% / 11);
      height: inherit;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 2;

      &:not(&:last-child) {
        border-right: 1px solid var(--border-color);
      }
    }
  }
}
</style>
<style>
.colorpicker {
  position: fixed !important;
  bottom: 10% !important;
  right: 31% !important;
  z-index: 9998 !important;
}
</style>
